import { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import { useSetTranslation } from '@context/TranslationContext'
import { setLanguage, getLanguage } from '@utils/sessionLanguage'
import useSWR from 'swr'
import useT from '@hooks/useTranslation'
import apiFetcher from '@api/apiFetcher'
import langs from '@constants/values/langs'

import styles from 'styles/Langs.module.css'

const DEFAULT = langs[0]
const routerLangs = {
    'pl-PL': 'pl',
    'en-GB': 'en',
    'de-DE': 'de',
    'uk-UA': 'ua',
    'pl': 'pl-PL',
    'en': 'en-GB',
    'de': 'de-DE',
    'ua': 'uk-UA',
}

const Lang = () => {
    const setT = useSetTranslation()
    const [lang, setLang] = useState('')
    const [open, setOpen] = useState(false)
    const [translations, setTranslations] = useState(null)
    const currentLang = useT('') || DEFAULT

    const router = useRouter()

    useEffect(() => {
        const l = resolveLang(router)
        if (l !== lang) setLang(l)
    }, [])

    const shouldFetch = lang && lang !== currentLang && (
        translations
            ? translations[""] !== lang
            : true
    )

    const { data } = useSWR(
        shouldFetch
            ? `/api/lang?l=${lang}`
            : null, apiFetcher)

    if (shouldFetch && data) {
        setTranslations(data)
    }

    useEffect(() => {
        if (translations && lang !== currentLang) {
            setT(translations)
            setLanguage(lang)
        }
    }, [translations])

    const changeLanguage = ({ currentTarget }) => {
        const l = currentTarget.getAttribute('value')
        setLanguage(l)
        setLang(l)
        setOpen(false)
        const { pathname, asPath, query } = router
        router.push({ pathname, query }, asPath, { locale: routerLangs[l] })
    }

    const toggleOpen = () => setOpen(!open)

    return (
        <aside>
            <Flag l={currentLang} onClick={toggleOpen} />
            <LangPicker
                open={open}
                callback={changeLanguage}
                currentLang={currentLang} />
        </aside>
    )
}

export function Flag ({ l, onClick, style }) {
    const alt = useT('Portal ogłoszeń motoryzacyjnych w języku polskim')
    return (
        <div value={l} className={styles.flag} onClick={onClick} style={style}>
            <img
                src={`/svg/${l}.svg`}
                alt={alt}
                width="25"
                height="23" />
            <span>{l.toUpperCase()}</span>
        </div>
    )
}

export function LangPicker ({ open, callback, currentLang }) {
    if (!open) return null
    return (
        <div className={styles.picker}>
            { langs.map(l => {
                return (l === currentLang
                    ? null
                    : <Flag key={l} l={l} onClick={callback} />)}) }
        </div>
    )
}

function resolveLang (router) {
    return routerLangs[router.locale] || getLanguage()
}

export default Lang